var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.566,
    height: 49.568,
    viewBox: "0 0 49.566 49.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_16",
    "data-name": "Gruppe 16",
    transform: "translate(-1866.42 -614.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surface5399",
    transform: "translate(1866.42 614.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    d: "M5.307,3C.45,18.8,3.346,30.486,13.213,33.519a21.263,21.263,0,0,0,2.5.589,15.4,15.4,0,0,1-.492-3.808,21.34,21.34,0,0,1,.807-5.849,77.254,77.254,0,0,0-4.421-7.914,2.065,2.065,0,0,1,3.437-2.291c.137.21,1.484,2.259,3.1,5.252a22.588,22.588,0,0,1,7.6-7.624C22.063,8.107,15.5,5.041,5.307,3Zm36.877,8.616c-12.021,0-22.831,6.978-22.831,18.684a14,14,0,0,0,4.34,9.536A81.736,81.736,0,0,0,19.611,49.9a2.067,2.067,0,1,0,3.953,1.21,82.037,82.037,0,0,1,8.955-18.571,66.7,66.7,0,0,1,9.85-11.787,2.063,2.063,0,1,1,2.832,3A68.915,68.915,0,0,0,30.647,44.273a10.7,10.7,0,0,0,3.235.557c11.4,0,18.684-6.922,18.684-22.831V11.616Zm0,0",
    transform: "translate(-3 -3)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.714345459789320e55739b6f2cdd9814.svg";
export { ForwardRef as ReactComponent };